import { render, staticRenderFns } from "./CentroAyuda.vue?vue&type=template&id=3c50b358&scoped=true&"
import script from "./CentroAyuda.vue?vue&type=script&lang=js&"
export * from "./CentroAyuda.vue?vue&type=script&lang=js&"
import style0 from "./CentroAyuda.vue?vue&type=style&index=0&id=3c50b358&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c50b358",
  null
  
)

export default component.exports